import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

// Send a message
export const sendMessage = createAsyncThunk('message/send', async (data, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/messages/send', data)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

// Fetch inbox messages
export const fetchInboxMessages = createAsyncThunk('message/fetchInbox', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/messages/inbox')
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

// Fetch sent messages
export const fetchSentMessages = createAsyncThunk('message/fetchSent', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/messages/sent')
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

// Fetch draft messages
export const fetchDraftMessages = createAsyncThunk('message/fetchDrafts', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/messages/drafts')
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

// Save a draft message
export const saveDraftMessage = createAsyncThunk('message/saveDraft', async (data, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/messages/draft', data)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

// Delete a draft message
export const deleteDraftMessage = createAsyncThunk('message/deleteDraft', async (messageId, { rejectWithValue }) => {
  try {
    const response = await api.delete(`/v1/messages/draft/${messageId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

// Get unread message count
export const fetchUnreadCount = createAsyncThunk('message/fetchUnreadCount', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/messages/unread-count')
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})